<template>
  <v-app class="questionnaire-layout">
    <Navbar toolbarColor="white" />

    <slot name="sidenav">
      <side-navbar
        v-if="$vuetify.breakpoint.mdAndDown && showSidenav"
        @toggleSidenav="showSidenav = !showSidenav" />
    </slot>

    <v-main>
      <slot />
    </v-main>

    <Footer />
  </v-app>
</template>

<script>
import Footer from '@/modules/shared/components/ui/Footer'
import Navbar from '@/modules/shared/components/ui/Navbar'
import SideNavbar from '@/modules/shared/components/ui/SideNavbar'

export default {
  name: 'QuestionnaireLayout',
  components: {
    Footer,
    Navbar,
    SideNavbar,
  },
  data: () => ({
    showSidenav: false,
  }),
}
</script>

<style lang="scss" scoped>
.questionnaire-layout {
  background: #F7F7F7;

  main, .v-main {
    padding: 100px 0 66px 0 !important;
  }
}
</style>
